
<div class="table-responsive">

  <table class="rounded table text-dark table-striped clickable">

    <thead>
      <th>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.LISTVIEW.HEADER.DATE' | translate}}</th>
      <th>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.LISTVIEW.HEADER.TIME' | translate}}</th>
      <th>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.LISTVIEW.HEADER.TYPE' | translate}}</th>
      <th>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.LISTVIEW.HEADER.REFERENCE' | translate}}</th>
      <th>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.LISTVIEW.HEADER.METHOD' | translate}}</th>
      <th>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.LISTVIEW.HEADER.PAYMENTMETHOD' | translate}}</th>
      <th>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.LISTVIEW.HEADER.HANDLED' | translate        }}</th>
      <th>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.LISTVIEW.HEADER.STATUS' | translate}}</th>
      <th>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.LISTVIEW.HEADER.DETAILS' | translate}}</th>
      <th class="text-end">{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.LISTVIEW.HEADER.AMOUNT' | translate}}</th>
    </thead>

    <tbody>

      @if (pagedHistoryLines !== null && pagedHistoryLines.length == 0) {
        <tr>
          <td colspan="10">{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.LISTVIEW.NO-RESULT' | translate}}</td>
        </tr>
      } @else {
        @for (pl of pagedHistoryLines; track pl) {
          <tr>
            <td style="width: 100px">{{pl.ReceivedTimeStamp | localDateTime | slice:0:10  | replaceOnEmpty }}</td>
            <td>{{pl.ReceivedTimeStamp | localTime | replaceOnEmpty }}</td>
            <td>{{pl.Type }}</td>
            <td>{{pl.PaymentReference | replaceOnEmpty }}</td>
            <td>{{pl.PaymentMethodName }}</td>
            <td>
              @switch (pl.PaymentTypeId) {
                @case (1) {
                  <span>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.PAYMENT-TYPE.DEBIT-CARD' | translate}}</span>
                }
                @case (2) {
                  <span>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.PAYMENT-TYPE.CASH' | translate}}</span>
                }
                @case (3) {
                  <span>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.PAYMENT-TYPE.OTHER' | translate}}</span>
                }
                @case (4) {
                  <span>{{'SALES.ORDERS.DETAILS.DIALOG.PAYMENT-OVERVIEW.PAYMENT-TYPE.CREDIT' | translate}}</span>
                }
                @default {
                  <span>-</span>
                }
              }
            </td>
            <td>{{pl.Handled | booleantype }}</td>
            <td>{{ getPaymentStatusText(pl.PaymentStatus) | replaceOnEmpty }}</td>
            <td style="width: 600px;">{{pl.Description | replaceOnEmpty }}</td>
            <td class="text-end">{{ pl.Amount | currency:'EUR' | replaceOnEmpty }}</td>
          </tr>
        }
      }


    </tbody>
  </table>

</div>

<div class="list-actions">
  <input type="checkbox" id="showDetails"  name="showDetails" (change)="onShowDetailsChange($event)" [checked]="false" /> <label for="showDetails">&nbsp;{{'GENERIC.BTN.SHOW-DETAILS' | translate}} </label>
</div>


<t4-pager (onPage)="doHistoryPage($event)" #historyPagerComponent></t4-pager>







